import {PageTemplate} from "../../shared/layout/PageTemplate";
import {FunctionsContent} from "./componenets/FunctionsContent";

export function Functions() {
    return <PageTemplate pageName="Functions" title="Enum" content={<FunctionsContent/>}/>

}